export default {
  DefaultName: 'This Caregiver',
  Title: 'Credentials & Verification',
  Subtitle: '#{name} has the following qualifications, experience, and/or background checks',
  PreVettedTitle: '#{name} is Pre-Vetted',
  PreVettedSubtitle: 'We\'ve personally screened #{name} to ensure they have the right qualifications and experience to provide top-quality care',
  CaregiverInfo: {
    PSW: {
      Type: 'Personal Support Worker',
      Place: 'Issued by #{orgName}',
      Label: 'Professional Certification',
    },
    DSW: {
      Type: 'Developmental Support Worker',
      Place: 'Issued by #{orgName}',
      Label: 'Professional Certification',
    },
    RN: {
      Type: 'Registered Nurse',
      Place: 'Issued by #{orgName}',
      Label: 'Professional License',
    },
    PAB: {
      Type: 'Préposé aux bénéficiaires',
      Place: 'Issued by #{orgName}',
      Label: 'Professional Credential',
    },
    CNA: {
      Type: 'Certified Nursing Assistant',
      Place: 'Issued by #{orgName}',
      Label: 'Professional Credential',
    },
    RPN: {
      Type: 'Registered Practical Nurse',
      Place: 'Issued by #{orgName}',
      Label: 'Professional Credential',
    },
    RNA: {
      Type: 'Registered Nursing Assistant',
      Place: 'Issued by #{orgName}',
      Label: 'Professional License',
    },
    HCA: {
      Type: 'Health Care Aide',
      Place: 'Issued by #{orgName}',
      Label: 'Professional Certificate',
    },
    PSW_STUDENT: {
      Type: 'Personal Support Worker Student',
      Place: 'Enrolled at #{orgName}',
      Label: 'Experienced Caregiver',
    },
    NURSING_STUDENT: {
      Type: 'Nursing Student',
      Place: 'Enrolled at #{orgName}',
      Label: 'Experienced Caregiver',
    },
    UNACCREDITED: {
      Type: 'Caregiving Companion',
      Place: 'Recognized by #{orgNameDefault}',
      Label: 'Experienced Caregiver',
    },
    FIRST_AID: {
      Type: 'First Aid Certification',
      Place: 'Issued by #{orgName}',
      Label: 'Training Certificate',
    },
    CPR: {
      Type: 'CPR Certification',
      Place: 'Issued by #{orgName}',
      Label: 'Training Certificate',
    },
    CSW: {
      Type: 'Community Service Worker',
      Place: 'Issued by #{orgName}',
      Label: 'Professional Certificate',
    },
    SSW: {
      Type: 'Social Service Worker',
      Place: 'Issued by #{orgName}',
      Label: 'Professional Certificate',
    },
  },
  BgCheckTitle: 'Background Check Cleared',
  BgCheckSubtitle: 'Issued by #{orgNameDefault}',
  BgCheckLabel: 'Background Verification',
  LiabilityInsuranceTitle: 'Liability Insurance',
  LiabilityInsuranceSubtitle: 'Issued by #{orgNameDefault}',
  LiabilityInsuranceLabel: 'Insurance Coverage',
  OrgNameDefault: 'accredited organization',
  VerifiedLabel: 'Verified',
};
